import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function Input({
  ref,
  id,
  className,
  inputClassName,
  placeholder,
  label,
  suffix,
  suffixNoStyle = false,
  prefix,
  prefixNoStyle = false,
  type,
  rows = 3,
  onChange,
  onBlur,
  onFocus,
  onKeyDown,
  value,
  clearButton = false,
  size = "md",
  hasError,
  disabled,
  required,
}: {
  ref?: React.Ref<HTMLInputElement> | React.Ref<HTMLTextAreaElement>;
  id?: string;
  className?: string;
  inputClassName?: string;
  placeholder?: string;
  label?: string;
  suffix?: React.ReactNode;
  suffixNoStyle?: boolean;
  prefix?: React.ReactNode;
  prefixNoStyle?: boolean;
  clearButton?: boolean;
  type: string;
  rows?: number;
  onChange?: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void;
  onBlur?: (
    e:
      | React.FocusEvent<HTMLInputElement>
      | React.FocusEvent<HTMLTextAreaElement>,
  ) => void;
  onFocus?: (
    e:
      | React.FocusEvent<HTMLInputElement>
      | React.FocusEvent<HTMLTextAreaElement>,
  ) => void;
  onKeyDown?: (
    e:
      | React.KeyboardEvent<HTMLInputElement>
      | React.KeyboardEvent<HTMLTextAreaElement>,
  ) => void;
  value?: string;
  size?: "sm" | "md" | "lg";
  hasError?: boolean;
  disabled?: boolean;
  required?: boolean;
}) {
  const hasPrefix = prefix !== undefined;
  const hasSuffix = suffix !== undefined;
  let inputRoundnessClass = "";
  if (hasPrefix && !hasSuffix) {
    inputRoundnessClass = "rounded-r-md";
  } else if (!hasPrefix && hasSuffix) {
    inputRoundnessClass = "rounded-l-md";
  } else {
    inputRoundnessClass = "rounded-md";
  }

  const isTextarea = type === "textarea";

  const inputcc = `
    w-full
    border-1
    border-gray-300
    ${inputRoundnessClass}
    p-2
    bg-white
    disabled:bg-gray-100
    disabled:text-gray-400
    disabled:cursor-not-allowed
    focus-visible:outline-2
    focus-visible:outline-offset-[-2px]
    focus-visible:outline-style-solid
    focus-visible:outline-blue-500
    ${inputClassName}
    ${
      hasError
        ? "border-red-500"
        : "" +
          " " +
          (size === "sm" ? "text-xs" : size === "md" ? "text-sm" : "text-base")
    }`;

  return (
    <div className={`${className ?? ""}`}>
      {label && (
        <label
          className={`block text-sm font-medium ${disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-500"}`}
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="flex">
        {prefix && prefixNoStyle && prefix}
        {prefix && !prefixNoStyle && (
          <div className="border-y-1 border-l-1 border-gray-300 rounded-l-md bg-gray-200 px-3 flex items-center justify-center">
            {prefix}
          </div>
        )}
        <div className="relative grow">
          {isTextarea ? (
            <textarea
              ref={ref as React.Ref<HTMLTextAreaElement>}
              className={inputcc}
              disabled={disabled}
              id={id}
              placeholder={placeholder}
              rows={rows}
              value={value}
              onBlur={onBlur}
              onChange={onChange}
              onFocus={onFocus}
              onKeyDown={onKeyDown}
            />
          ) : (
            <input
              ref={ref as React.Ref<HTMLInputElement>}
              className={inputcc}
              disabled={disabled}
              id={id}
              placeholder={placeholder}
              type={type}
              value={value}
              onBlur={onBlur}
              onChange={onChange}
              onFocus={onFocus}
              onKeyDown={onKeyDown}
            />
          )}
          {clearButton && value !== "" && (
            <button
              className={`absolute ${type === "date" ? "right-8" : "right-2"} top-1/2 -translate-y-1/2 cursor-pointer`}
              type="button"
              onClick={() =>
                onChange?.({
                  target: { value: "" },
                } as React.ChangeEvent<HTMLInputElement>)
              }
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )}
        </div>
        {suffix && suffixNoStyle && suffix}
        {suffix && !suffixNoStyle && (
          <div className="border-y-1 border-r-1 border-gray-300 rounded-r-md bg-gray-200 px-3 flex items-center justify-center">
            {suffix}
          </div>
        )}
      </div>
    </div>
  );
}
